const unifiedConsole = {
  roleLabel: {
    orgManager: "Org Manager",
    manager: "Manager",
    researcher: "Researcher",
  },
  loadError: "Failed to load console",
  noData: "No console data available",
  welcomeBack: "Welcome back",
  defaultUserName: "there",
  metrics: {
    project_one: "Project",
    project_other: "Projects",
    dataRequests: "Data Requests",
    availableDatasets: "Available Datasets",
  },
  actions: {
    browseDatasets: "Browse Datasets",
    newDataRequest: "New Data Request",
    deidentifyFile: "De-identify a File",
  },
  attention: {
    heading: "Needs your attention",
    empty: "Nothing to review right now.",
    requestedBy: "{{userName}} requests ",
    projectFallback: "Project {{id}}",
    requestedOn: " · Requested {{date}}",
    review: "Review",
  },
  yourRequests: {
    heading: "Your requests",
    viewAll: "View all",
    summary: "{{pending}} pending · {{resolved}} resolved",
  },
  yourProjects: {
    heading: "Your projects",
    emptyManager: "No projects yet. Create one to get started.",
    emptyOther: "Contact an administrator to get access to a research project.",
    owner: "Owner",
  },
  projectSelector: {
    title: "Select Project",
    prompt: "Choose a project:",
  },
};

export default unifiedConsole;
